import { Component, Input, inject } from '@angular/core';
import { TabService } from '@services/tabs/TabService';
import { Pages } from '@constants/pages/Pages';
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";

@Component({
    selector: 'moi-event-summary',
    templateUrl: './moi-event-summary.component.html',
    styleUrls: ['./moi-event-summary.component.scss'],
    imports: [TranslatePipe, DateInputComponent, InputTooltipDirective],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiEventSummaryComponent {
  private tabservice = inject(TabService);
  private pages = inject(Pages);

  @Input() summaryModel: any;
  @Input() eventID: any;

  openEvent() {
      if (!this.eventID || !this.summaryModel.CanOpenParent) {
          return;
      }

      this.tabservice.generateTab(this.pages.EventDetail, this.eventID);
  }
}
